import { apiURL, responseFormat } from '@/service/base'
import { MembersClient } from '@circusmonkey/spock-protobuf/ts/frontend/member_grpc_web_pb.js'

const client = new MembersClient(apiURL, null, null)

/**
 * 取banner清單
 * @param func
 * @returns {Promise<unknown>}
 */
async function getBannerList(params = {}, func = null) {
	const req = new proto.base.Empty()

	const option = { 'grpc-session': localStorage.getItem('grpc-session') }
	const url = String(client.getBanners.toString().split('\n')[2]).replace(/\s+/g, '')
	const track = { req: req.toObject(), url }
	return new Promise((resolve, reject) => {
		client.getBanners(req, option, (err, response) => {
			if (typeof func === 'function') resolve(func(err, response, track))
			else resolve(responseFormat(err, response, track, true, 'banner'))
		})
	}).then(resp => resp)
}

export {
	getBannerList
}
